import MediaLibraryClient from '../clients/MediaLibraryClient';

export default class MediaLibrarySearchLink
{
    constructor()
    {
        // Imports
        this.mediaLibraryClient = new MediaLibraryClient();

        // Helper
        this.assetLimit = 1000;
        this.getParamLimit = 2000;
    }

    /**
     * @param {HTMLElement} link
     * @param {HTMLElement} note
     */
    init(link, note = null)
    {
        this.link = link;
        this.note = note;

        if (orion.getShopViewCode() === 'desktop' && this.link)
        {
            this.getDataAttributes();
            this.handleLink();
        }
    }

    getDataAttributes()
    {
        this.searchField = this.link.getAttribute('data-ml-search-field');
        this.searchValue = this.link.getAttribute('data-ml-search-value');
    }

    handleLink()
    {
        if (this.searchField === 'batch')
        {
            if (this.searchValue.length <= this.getParamLimit)
            {
                this.mediaLibraryClient.fetchAssetsByBatchSearch(
                    [],
                    this.searchValue.split(','),
                    false,
                    false,
                    false,
                    false,
                    1,
                    0
                )
                    .then(response => response.json())
                    .then(assets =>
                    {
                        if (assets.totalItems !== 0 && assets.totalItems <= this.assetLimit)
                        {
                            this.link.classList.remove('hidden');
                        }
                        else
                        {
                            if (this.note) this.note.classList.remove('hidden');
                        }
                    });
            }
            else
            {
                if (this.note) this.note.classList.remove('hidden');
            }
        }
        else
        {
            this.mediaLibraryClient.fetchAssetsBySearchTerm(
                this.searchField,
                this.searchValue,
                false,
                false,
                false,
                false,
                1,
                0
            )
                .then(response => response.json())
                .then(assets =>
                {
                    if (assets.totalItems !== 0)
                    {
                        this.link.classList.remove('hidden');
                    }
                    else
                    {
                        this.searchValue = this.searchValue.slice(0, 7);

                        this.handleLink();
                    }
                });
        }
    }
}
